import { createStore } from 'hox';
import { trpc } from '@bitbot/api';
import { useRouter } from 'next/router';
import { useToken } from '../user/token';
import { useEffect, useState } from 'react';
import { toastError } from '@bitbot/ui-design';
import { isEmpty } from 'lodash';

type DataType = {
  avatar?: string | null;
  nickname?: string | null;
  meme_amount: string;
  fail?: boolean;
};

export const [useClaim, ClaimProvider] = createStore(() => {
  const { hasLogin } = useToken();
  const router = useRouter();
  const { wallet, chain, signature, tgExt, chat_id, message_id } =
    router.query;
  const [res, setRes] = useState<DataType>();
  const claimMutation = trpc.claim.claimAmount.useMutation({});

  const claim = async () => {
    try {
      const data = await claimMutation.mutateAsync({
        chain: chain as string,
        wallet: wallet as string,
        signature: signature as string,
        tgExt: tgExt as string,
        chat_id: chat_id as string,
        message_id: message_id ? Number(message_id) : 0,
      });
      if (data) {
        setRes({
          avatar: data.avatar ?? '/images/avatar.png',
          nickname: data.nickname ?? '',
          meme_amount: data.amount.toString() ?? '0',
        });
      } else {
        setRes({
          avatar: '/images/avatar.png',
          nickname: 'Claim failed',
          meme_amount: '0',
          fail: true,
        });
      }
    } catch (error: any) {
      toastError('Claimed failed:' + error.message);
      setRes({
        avatar: '/images/avatar.png',
        nickname: 'Claim failed',
        meme_amount: '0',
        fail: true,
      });
    }
  };
  useEffect(() => {
    if (hasLogin && !isEmpty(router.query)) {
      claim();
    }
  }, [hasLogin, router.query]);
  return {
    wallet,
    res,
  };
});
